export default __webpack_public_path__ + "static/media/Hemkunskap7.843d9301.jpeg";